import type { TFunction } from 'i18next'

export type HubReturnFailureReason = 'transportError' | 'timeout'

type HubReturnErrorMessage = { header: string; copy: string }

export const getHubReturnErrorMessage = (
  reason: HubReturnFailureReason | undefined,
  t: TFunction,
): HubReturnErrorMessage => {
  switch (reason) {
    case 'timeout':
      return {
        header: t('adFleetMap_toast_hubReturnFailedTimeout_header'),
        copy: t('adFleetMap_toast_hubReturnFailedTimeout_caption'),
      }
    case 'transportError':
      return {
        header: t('adFleetMap_toast_hubReturnFailedConnection_header'),
        copy: t('adFleetMap_toast_hubReturnFailedConnection_caption'),
      }
    default:
      return {
        header: t('adFleetMap_toast_hubReturnFailed_header'),
        copy: t('adFleetMap_toast_hubReturnFailed_caption'),
      }
  }
}
